import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

export const Stars = ({ n, size = 14 }) => (
  <span className="inline-flex gap-0.5 text-[#C9A24B]" aria-label={`${n} sur 5`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={size} fill={i <= n ? "currentColor" : "none"} className={i <= n ? "" : "opacity-30"} />)}
  </span>
);

export const ReaderReviews = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/reviews").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <div className="mt-12" data-testid="reader-reviews">
      <p className="text-center font-ui text-xs tracking-[0.25em] uppercase text-[#C9A24B]">Ils ont vécu le Tao des 4C</p>
      <div className="mt-6 flex flex-wrap justify-center gap-4">
        {items.slice(0, 6).map((r, i) => (
          <figure key={r.id} data-testid={`review-${r.id}`} style={{ animationDelay: `${i * 80}ms` }}
            className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.7rem)] rounded-2xl bg-white/5 border border-[#C9A24B]/20 p-5 text-left animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both">
            <Quote size={18} className="text-[#C9A24B]/60" />
            <blockquote className="font-serif italic text-[15px] leading-relaxed text-[#F6F2E9]/90 mt-2 whitespace-pre-line">{r.text}</blockquote>
            <figcaption className="mt-4 flex items-center justify-between gap-2">
              <span className="font-sans text-sm text-[#F6F2E9]">{r.name}{r.detail && <span className="block text-xs text-[#F6F2E9]/50">{r.detail}</span>}</span>
              <Stars n={r.rating} />
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};
